import StoreItemTable from './StoreItemTable';
import { StoreItemPlaceholderProps } from './StoreProductsTable.types';

const StoreItemTablePlaceholder = (props: StoreItemPlaceholderProps) => {
  const { storeNumber, loading } = props;
  return (
    <StoreItemTable store={{ storeNumber, categories: [] }} products={[]} editable={false} loadingData={loading} />
  );
};

export default StoreItemTablePlaceholder;
